// extracted by mini-css-extract-plugin
export default {"closedBanner":"styles__closedBanner___C2Aw_"};